import React, { useEffect, useState } from "react";
import { api, brl, formatDateTime } from "../../lib/api";
import { toast } from "sonner";
import { ShieldCheck, ArrowDown, ArrowUp } from "@phosphor-icons/react";

export default function AdminInsurance() {
  const [data, setData] = useState(null);
  const [rate, setRate] = useState("");

  const load = async () => {
    const { data } = await api.get("/insurance/overview");
    setData(data);
    setRate(String(data.rate_percent));
  };
  useEffect(() => { load(); }, []);

  const saveRate = async () => {
    try {
      const decimal = Math.max(0, Math.min(0.2, Number(rate) / 100));
      await api.post("/insurance/rate", { rate: decimal });
      toast.success("Taxa atualizada");
      load();
    } catch { toast.error("Erro"); }
  };

  if (!data) return <div className="text-sm tracking-widest uppercase text-[#5C5A57]">Carregando...</div>;

  return (
    <div data-testid="admin-insurance-page">
      <div className="topbar">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Fundo de protecao</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Seguro Anti-Calote</h1>
        </div>
        <ShieldCheck size={42} weight="duotone" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="kpi-card border-l-4" style={{ borderLeftColor: "#0A0A0A" }}>
          <div className="kpi-label">Saldo do fundo</div>
          <div className="kpi-value tabular">{brl(data.balance)}</div>
          <div className="text-xs text-[#5C5A57] mt-2">Disponivel para compensar perdas</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-label">Total arrecadado</div>
          <div className="kpi-value tabular">{brl(data.total_in)}</div>
          <div className="text-xs text-[#5C5A57] mt-2">{data.contributions_count} contribuicoes</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-label">Total compensado</div>
          <div className="kpi-value tabular">{brl(data.total_out)}</div>
          <div className="text-xs text-[#5C5A57] mt-2">{data.claims_count} sinistros</div>
        </div>
        <div className="kpi-card bg-[#F5F0EB]">
          <div className="kpi-label">Taxa atual</div>
          <div className="kpi-value tabular">{data.rate_percent}%</div>
          <div className="flex items-center gap-2 mt-3">
            <input
              type="number" step="0.1" min="0" max="20"
              value={rate} onChange={(e) => setRate(e.target.value)}
              className="input-underline tabular" style={{ maxWidth: 80 }}
              data-testid="rate-input"
            />
            <span className="text-xs text-[#5C5A57]">%</span>
            <button onClick={saveRate} className="brand" style={{ padding: "8px 14px", fontSize: 10 }} data-testid="save-rate-btn">Salvar</button>
          </div>
        </div>
      </div>

      <h2 className="section-title mb-4">Historico recente</h2>
      <div className="table-wrap">
        <table className="crl">
          <thead><tr><th>Quando</th><th>Tipo</th><th>Cliente</th><th>Valor</th></tr></thead>
          <tbody>
            {data.recent.map((r) => (
              <tr key={r.id}>
                <td className="text-[#5C5A57] text-xs">{formatDateTime(r.at)}</td>
                <td>
                  {r.type === "contribution" ? (
                    <span className="flex items-center gap-1 text-[#2D5A33]"><ArrowUp size={14} /> Contribuicao</span>
                  ) : (
                    <span className="flex items-center gap-1 text-[#7A2D2B]"><ArrowDown size={14} /> Sinistro</span>
                  )}
                </td>
                <td className="text-[#5C5A57] text-xs">{r.client_id?.slice(0, 8)}</td>
                <td className={`tabular font-medium ${r.amount < 0 ? "text-[#7A2D2B]" : "text-[#2D5A33]"}`}>
                  {brl(r.amount)}
                </td>
              </tr>
            ))}
            {data.recent.length === 0 && <tr><td colSpan="4" className="text-center text-sm text-[#5C5A57] py-8">Sem movimentacoes ainda.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
